import styles from './style.module.scss';

/**
 * Discount promo code notice layouts
 * @typedef {Object} DiscountPromoCodeNoticeLayouts
 * @property {string} COLUMN Column layout - terms and conditions shown on next row.
 * @property {string} ROW Row layout - terms and conditions shown in a row with promo code.
 */
export const LAYOUTS = {
    COLUMN: styles.columnLayout,

    // default styles
    ROW: 'row'
};
